import { Injectable } from '@angular/core';
import { UserSelectors } from '@elio/emanager-front/auth/state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IsSuperAdminGuard {
  constructor(private store: Store) {}

  canMatch = (): Observable<boolean> => this.store.select(UserSelectors.isSuperAdmin);
}
